<template>
  <div class="Registration">
    <el-form
      :model="ruleForm"
      status-icon
      :rules="rules"
      ref="ruleForm"
      class="demo-ruleForm"
      :align="center"
    >
      <h3 style="margin-bottom: 20px; margin-top: 30px; text-align: center">
        注册
      </h3>
      <el-form-item prop="username" label-width="auto">
        <el-input
          type="username"
          v-model="ruleForm.username"
          autocomplete="off"
          placeholder="邮箱或者手机号"
          style="width: 50%"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password" label-width="auto">
        <el-input
          v-model="ruleForm.password"
          placeholder="输入密码:"
          autocomplete="off"
          type="password"
          show-password
          style="width: 50%"
        ></el-input>
      </el-form-item>
      <el-form-item prop="checkPass" label-width="auto">
        <el-input
          type="password"
          v-model="ruleForm.checkPass"
          placeholder="再次确认密码:"
          show-password
          style="width: 50%"
        ></el-input>
      </el-form-item>
      <el-form-item style="margin-right: 80px" label-width="auto">
        <el-checkbox v-shake v-model="checked" :class="{ 'apply-shake': shake }"
          >我已阅读并同意<a
            href="https://miaodaokeji.com/protocol/agreement.html"
            style="color: #00bfff"
            >用户注册协议</a
          ></el-checkbox
        >
      </el-form-item>
      <el-form-item class="btn-footer">
        <el-row :gutter="20">
          <el-col :span="12" :offset="6">
            <el-button
              style="width: 100%"
              type="primary"
              @click="submitForm('ruleForm')"
              >注 册</el-button
            >
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" :offset="6">
            <el-button style="width: 100%" @click="goLogin('ruleForm')"
              >返回登录</el-button
            >
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
// import axios from 'axios';
export default {
  data() {
    // 密码验证
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass');
        }
        callback();
      }
    };
    // 再次确认密码
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        username: '',
        password: '',
        checkPass: '',
      },
      checked: null,
      shake: false,
      rules: {
        username: [{ validator: validatePass, trigger: 'blur' }],
        password: [{ validator: validatePass2, trigger: 'blur' }],
        checkPass: [{ validator: validatePass2, trigger: 'blur' }],
      },
    };
  },
  methods: {
    submitForm(formName) {
      if (!this.checked) {
        this.shake = true;
        setTimeout(() => {
          this.shake = false;
        }, 820); // 动画持续时间为0.82s
        return this.$message.warning('请勾选协议');
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const payload = {
            username: this.ruleForm.username,
            pwd: this.ruleForm.password,
            cpwd: this.ruleForm.checkPass,
          };
          this.$axios
            .post('wb/index.php/Newicp/regitst', payload, {
              headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': '*',
              },
              withCredentials: true,
            })
            .then((res) => {
              if (res.data.status === 1) {
                this.$message({
                  message: '注册成功，请返回登陆',
                  type: 'success',
                });
              } else {
                this.$message({
                  message: res.data.info,
                  type: 'warning',
                });
              }
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    goLogin() {
      console.log(this.$emit('loginFlag'), 'loginFlag');
      this.$emit('loginFlag');
    },
  },
};
</script>
<style>
.demo-ruleForm {
  border: 1px solid black;
}

.btn-footer .el-row {
  margin: 20px 0;
}

@keyframes shake {
  /* 水平抖动，核心代码 */

  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(+2px, 0, 0);
  }

  30%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(+4px, 0, 0);
  }

  50% {
    transform: translate3d(-4px, 0, 0);
  }
}
.apply-shake {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}
</style>
